import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	clientsTableData: [],
	clientsFormData: {},
	isClientDataLoaded: false,
}

const getters = {
	getClientsFormData (state, {clientsFormData}) {
		var getData = state.clientsFormData
		return getData;
	}
}


// mutations
const mutations = {
	SET_IS_LOADED (state){
		state.isClientDataLoaded = true
	},

	SET_CLIENTS_TABLE_DATA (state, {clientsTableData}){
		state.clientsTableData = clientsTableData
	},

	SET_CLIENTS_FORM_DATA (state, {clientsFormData}){
		state.clientsFormData = clientsFormData
	}
}

// actions
const actions = {
	getClients ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.api_url+'v1/clients?paginate=false';
		
		var tableData = [];

		axios.get(url,header).then(response => { 
            var dataCtr = 0;
            var result = response.data.data;

            $.each(result, function(idx, arr){
                tableData[dataCtr] = [
                    arr['id'],
                    arr['client_name'],
                    arr['address1'],
                    arr['city'],
                    arr['state'],
                    arr['zipcode'],
                    arr['business_phone'],
                    arr['fax'],
                    arr['email']
                ];

                dataCtr++;
            });
            //console.log(tableData);
            commit('SET_IS_LOADED');
			commit('SET_CLIENTS_TABLE_DATA', {clientsTableData: tableData });
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true})
		});
	},

	setClientsFormData ({state, commit}, statusData){

		var result = {
			id: statusData[0],
			request_status: statusData[1]
		}

		commit('SET_CLIENTS_FORM_DATA', {clientsFormData: result});
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}